import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import axios from "axios";
import {
  JSON_BASE_API_URL,
  ROLL_CALL_API_BASE_URL,
} from "../../Pereco/RollCall/RollCallConfig/RollCallConfig";
import { Spin } from "antd";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImagesCrousel = [
  {
    image: "assets/img/fallbackImages/vertical-1.jpeg",
    title: "Urban Threads",
    category: "Fashion · E-Commerce",
    description: "Minimal clothing brand with responsive online store",
  },
  {
    image: "assets/img/fallbackImages/vertical-2.jpeg",
    title: "Skyline Realty",
    category: "Real Estate · Branding",
    description: "Property showcase website with premium visual identity",
  },
  {
    image: "assets/img/fallbackImages/vertical-3.jpeg",
    title: "FitZone Gym",
    category: "Fitness · Mobile App",
    description: "Fitness management app with class booking and memberships",
  },
];
const ImagesCrouselVertical = [
  {
    image: "assets/img/fallbackImages/horiz-1.jpeg",
    title: "Fallback 1",
    category: "",
  },
  {
    image: "assets/img/fallbackImages/horiz-2.jpeg",
    title: "Fallback 2",
    category: "",
  },
];

const fallbackTopCards = [
  {
    name: "Secure & Reliable",
    icon: "fas fa-shield-alt",
    bgColor: "#FBE8DA",
    iconColor: "#D96B2C",
    link: "",
    isFallback: true,
  },
  {
    name: "Fast & Simple",
    icon: "fas fa-bolt",
    bgColor: "#FBE8DA",
    iconColor: "#D96B2C",
    link: "",
    isFallback: true,
  },
  {
    name: "Mobile Friendly",
    icon: "fas fa-mobile-alt",
    bgColor: "#FBE8DA",
    iconColor: "#D96B2C",
    link: "",
    isFallback: true,
  },
  {
    name: "Always Supported",
    icon: "fas fa-headset",
    bgColor: "#FBE8DA",
    iconColor: "#D96B2C",
    link: "",
    isFallback: true,
  },
];

const topbarFallback = {
  contact: [
    {
      type: "whatsapp",
      label: "WhatsApp",
      icon: "ti ti-brand-whatsapp",
      link: "https://wa.me/918297230010",
      visible: true,
      color: "#25D366",
    },
    {
      type: "phone",
      label: "+91-8297230010",
      icon: "ti ti-phone-call",
      link: "tel:+918297230010",
      visible: true,
      color: "#28A745",
    },
  ],
  social: [
    {
      Name: "youtube",
      icon: "ti ti-brand-youtube-filled",
      link: "https://www.youtube.com/@perecoindia",
      visible: true,
      color: "#FF0000",
    },
    {
      Name: "facebook",
      icon: "ti ti-brand-facebook-filled",
      link: "https://www.facebook.com/Perecoindia/",
      visible: true,
      color: "#1877F2",
    },
    {
      Name: "instagram",
      icon: "ti ti-brand-instagram",
      link: "https://www.instagram.com/pereco_india/",
      visible: true,
      color: "#E4405F",
    },
    {
      Name: "twitter",
      icon: "ti ti-brand-x-filled",
      link: "https://x.com/PerecoIndia",
      visible: true,
      color: "#000000",
    },
  ],
};

const settings = {
  dots: true,
  infinite: true,
  speed: 600,
  autoplay: true,
  autoplaySpeed: 10000,
  pauseOnHover: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1200, // Laptop
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 992, // Tablet
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 576, // Mobile
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const verticalSettings = {
  dots: true,
  infinite: true,
  speed: 600,
  autoplay: true,
  autoplaySpeed: 10000,
  pauseOnHover: true,

  vertical: true, // Enable vertical sliding
  verticalSwiping: true, // Optional: allow swipe up/down

  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,

  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const carouselHeight = 420;

const Signin = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [Username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const route = all_routes;

  const [featureCards, setFeatureCards] = useState([]);
  const [dataloading, setdataloading] = useState(false);
  const [featureCarouselSlides, setFeatureCarouselSlides] = useState([]);
  const [topCards, setTopCards] = useState([]);
  const [topbar, setTopbar] = useState(topbarFallback);

  console.log(featureCards, "featureCards");
  useEffect(() => {
    const fetchData = async () => {
      setdataloading(true);

      try {
        const res = await axios.get(
          `${JSON_BASE_API_URL}/rollcalladmin-content`,
        );

        const data = res.data;

        if (data.cards && data.cards.length > 0) {
          setFeatureCards(data.cards);
        } else {
          setFeatureCards(ImagesCrousel);
        }
        if (data.featureCards && data.featureCards.length > 0) {
          setTopCards(data.featureCards);
        } else {
          setTopCards(fallbackTopCards);
        }
        if (data.carousel && data.carousel.length > 0) {
          setFeatureCarouselSlides(data.carousel);
        } else {
          setFeatureCarouselSlides(ImagesCrouselVertical);
        }
        if (data.topbar) {
          setTopbar({
            contact: data.topbar.contact || topbarFallback.contact,
            social: data.topbar.social || topbarFallback.social,
          });
        } else {
          setTopbar(topbarFallback);
        }
      } catch (error) {
        console.error("Error fetching content:", error);

        setFeatureCarouselSlides(ImagesCrouselVertical);
        setFeatureCards(ImagesCrousel);
        setTopCards(fallbackTopCards);
        setTopbar(topbarFallback);
      } finally {
        setdataloading(false);
      }
    };

    fetchData();
  }, []);

  const whatsapp =
    topbar.contact.find((x) => x.type === "whatsapp" && x.visible) ||
    topbarFallback.contact.find((x) => x.type === "whatsapp");

  const phone =
    topbar.contact.find((x) => x.type === "phone" && x.visible) ||
    topbarFallback.contact.find((x) => x.type === "phone");

  const youtube =
    topbar.social.find(
      (x) => x.Name.toLowerCase() === "youtube" && x.visible,
    ) || topbarFallback.social.find((x) => x.Name === "youtube");

  const facebook =
    topbar.social.find(
      (x) => x.Name.toLowerCase() === "facebook" && x.visible,
    ) || topbarFallback.social.find((x) => x.Name === "facebook");

  const instagram =
    topbar.social.find(
      (x) => x.Name.toLowerCase() === "instagram" && x.visible,
    ) || topbarFallback.social.find((x) => x.Name === "instagram");

  const twitter =
    topbar.social.find(
      (x) =>
        (x.Name.toLowerCase() === "twitter" || x.Name.toLowerCase() === "x") &&
        x.visible,
    ) || topbarFallback.social.find((x) => x.Name === "twitter");

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setloading(true);

    try {
      const response = await axios.post(
        `${ROLL_CALL_API_BASE_URL}portal/user/login`,
        { username: Username, password: password },
      );

      const { ResultData } = response.data;
      const { Token, IsAdmin, SuperId } = ResultData;

      if (Token && IsAdmin && SuperId) {
        sessionStorage.setItem("authToken", Token);
        sessionStorage.setItem("userData", JSON.stringify(ResultData));
        sessionStorage.setItem("superId", SuperId);

        try {
          const menuResponse = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/access/getmenu?UserId=${ResultData.UserId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Token}`,
              },
            },
          );

          const menuData = await menuResponse.json();

          if (menuData?.status && Array.isArray(menuData.ResultData)) {
            sessionStorage.setItem(
              "userMenu",
              JSON.stringify(menuData.ResultData),
            );

            const flatPermissions = {};
            const flatten = (items) => {
              items.forEach((item) => {
                if (item.link && item.link !== "#") {
                  flatPermissions[item.link] = {
                    canRead: item.canRead,
                    canWrite: item.canWrite,
                    canDelete: item.canDelete,
                    canExport: item.canExport,
                  };
                }
                if (
                  Array.isArray(item.submenuItems) &&
                  item.submenuItems.length > 0
                ) {
                  flatten(item.submenuItems);
                }
              });
            };

            flatten(menuData.ResultData);
            sessionStorage.setItem(
              "rollcall-permissions",
              JSON.stringify(flatPermissions),
            );
          }
        } catch (err) {
          console.error("Menu API error:", err);
        }

        navigate(`/${ResultData.DefaultPath}`);
      } else {
        alert("Access denied. Only Admins can access the dashboard.");
      }
    } catch (error) {
      alert("Login failed. Please check your credentials.");
      console.error("Login error:", error);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      navigate(route.rollcalldashboard, { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <style>{`
        .bg-cream { background-color: #FBF3E3; }
        .bg-terracotta { background-color: #D96B2C; }
        .bg-terracotta-dark { background-color: #C25A22; }
        .bg-stat { background-color: #F3E3C6; }
        .bg-navy { background-color: #1E2A3A; }
        .bg-green { background-color: #2F4A3C; }
        .bg-blue-lt { background-color: #CFE4F0; }
        .bg-red { background-color: #B5342A; }
        .bg-charcoal { background-color: #2b2b2b; }

        .text-terracotta { color: #D96B2C; }
        .text-navy { color: #1E2A3A; }

        .border-terracotta {
          border-color: #D96B2C !important;
        }
      `}</style>
      <div className="bg-cream text-navy">
        <nav className="navbar navbar-expand-lg bg-white shadow-sm py-2">
          <div className="container">
            <a className="navbar-brand ">
              <div className="" style={{ maxWidth: "150px" }}>
                <ImageWithBasePath
                  src="assets/img/logo.png"
                  alt="logo"
                  className="img-fluid "
                />
              </div>
            </a>
            <button
              className="navbar-toggler ms-auto"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navMenu"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navMenu">
              <ul className="navbar-nav ms-auto gap-lg-4 text-center">
                <li className="nav-item">
                  <a
                    className="nav-link fw-medium text-navy text-nowrap"
                    href={whatsapp?.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i
                      className={whatsapp?.icon}
                      style={{ color: whatsapp?.color }}
                    ></i>
                    <span>{whatsapp?.label}</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link fw-medium text-navy text-nowrap"
                    href={phone?.link}
                  >
                    <i
                      className={phone?.icon}
                      style={{ color: phone?.color }}
                    ></i>
                    <span>{phone?.label}</span>
                  </a>
                </li>
                <li className="nav-item">
                  <div className="nav-link fw-medium text-navy text-nowrap">
                    {youtube && (
                      <a
                        href={youtube.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="YouTube"
                      >
                        <i
                          className={`${youtube.icon} fs-4`}
                          style={{ color: youtube.color }}
                        ></i>
                      </a>
                    )}
                    {facebook && (
                      <a
                        href={facebook.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                      >
                        <i
                          className={`${facebook.icon} fs-4`}
                          style={{ color: facebook.color }}
                        ></i>
                      </a>
                    )}

                    {instagram && (
                      <a
                        href={instagram.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                      >
                        <i
                          className={`${instagram.icon} fs-4`}
                          style={{ color: instagram.color }}
                        ></i>
                      </a>
                    )}

                    {twitter && (
                      <a
                        href={twitter.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Twitter"
                      >
                        <i
                          className={`${twitter.icon} fs-4`}
                          style={{ color: twitter.color }}
                        ></i>
                      </a>
                    )}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <header className="py-2">
          <div className="container py-2">
            <div className="row align-items-start g-5">
              <div className="col-lg-8">
                <div>
                  {" "}
                  <h1 className="fw-bold display-1 mb-0">
                    Seamless Growth, Made Possible.
                  </h1>
                  <hr
                    className="border-4 border-terracotta opacity-100 my-1"
                    style={{ width: "140px" }}
                  />
                  <p className="text-secondary mb-2 w-75">
                    We craft brands, websites and digital products for
                    businesses across industries.
                  </p>
                  <div className="d-flex flex-wrap gap-3">
                    <a
                      href="https://www.perennialcode.in/solutions"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn text-white rounded-pill fw-semibold px-4 py-2"
                      style={{ backgroundColor: "#D96B2C" }}
                    >
                      Explore Our Work
                    </a>
                    <a
                      href="https://www.perennialcode.in/contactus"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn rounded-pill fw-semibold px-4 py-2"
                      style={{
                        border: "2px solid #D96B2C",
                        color: "#D96B2C",
                      }}
                    >
                      Get in Touch
                    </a>
                  </div>
                </div>
                <div className="row mt-1 g-3 text-center">
                  {topCards.map((item, index) => {
                    const isFallback = item.isFallback;

                    return (
                      <div className="col-md-3 col-6" key={index}>
                        <div
                          className="py-3 shadow rounded-4 h-100"
                          role={item.link ? "button" : undefined}
                          style={{
                            cursor: item.link ? "pointer" : "default",
                            transition: "0.3s",
                          }}
                          onClick={() => {
                            if (item.link) {
                              window.open(
                                item.link,
                                "_blank",
                                "noopener,noreferrer",
                              );
                            }
                          }}
                        >
                          <div
                            className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                            style={{
                              width: "70px",
                              height: "70px",
                              background: "#FBE8DA",
                            }}
                          >
                            {isFallback ? (
                              <i
                                className={item.icon}
                                style={{
                                  color: "#D96B2C",
                                  fontSize: "30px",
                                }}
                              />
                            ) : (
                              <i
                                className={item.svg}
                                style={{
                                  color: "#D96B2C",
                                  fontSize: "34px",
                                }}
                              />
                            )}
                          </div>

                          <h6 className="fw-bold text-navy mb-1">
                            {item.name}
                          </h6>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="col-lg-4">
                <div
                  className="card border-0 shadow rounded-4 mx-auto"
                  style={{ maxWidth: "380px" }}
                >
                  <div className="card-body p-4 px-md-5 py-4">
                    <h4 className="fw-bold mb-1">Welcome Back</h4>

                    <form onSubmit={handleLogin}>
                      <div className="mb-3 text-start">
                        <label
                          htmlFor="username"
                          className="form-label fw-medium small"
                        >
                          Username
                        </label>
                        <input
                          type="text"
                          className="form-control bg-cream"
                          id="username"
                          placeholder="Enter your username"
                          value={Username}
                          onChange={(e) => setUserName(e.target.value)}
                        />
                      </div>
                      <label
                        htmlFor="password"
                        className="form-label fw-medium small"
                      >
                        Password
                      </label>
                      <div className="mb-4 text-start input-group">
                        <input
                          type={isPasswordVisible ? "text" : "password"}
                          className="form-control bg-cream"
                          id="password"
                          placeholder="Enter your password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <button
                          type="button"
                          className="input-group-text bg-white border"
                          onClick={togglePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className={`ti ${
                              isPasswordVisible ? "ti-eye" : "ti-eye-off"
                            }`}
                          />
                        </button>
                      </div>
                      <button
                        type="submit"
                        className="btn text-white w-100 py-2 fw-semibold rounded-3"
                        disabled={loading}
                        style={{ backgroundColor: "#D96B2C" }}
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                          />
                        ) : (
                          "Sign In"
                        )}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
        <Spin spinning={dataloading} size="large" tip="Loading...">
          <section className="mb-4">
            <div className="container text-center">
              <p
                className="text-terracotta fw-bold small mb-1"
                style={{ letterSpacing: "1px" }}
              >
                OUR CLIENTS
              </p>
              <h2 className="fw-bold mb-3">Who We Work With</h2>
              <style>
                {`.img-blurred-bg {
                filter: blur(20px) brightness(0.7);
                transform: scale(1.15);
              }`}
              </style>
              <div className="row">
                <div className="col-12 col-lg-8">
                  <Slider {...settings}>
                    {featureCards.map((item, index) => {
                      const isFallback = item.isFallback;

                      return (
                        <div key={index}>
                          <div
                            className="card border-0 shadow-sm rounded-4 overflow-hidden"
                            style={{ height: carouselHeight }}
                          >
                            <div
                              className="position-relative bg-light"
                              style={{
                                aspectRatio: "9 / 16",
                                overflow: "hidden",
                              }}
                            >
                              {/* Background Image */}
                              {isFallback ? (
                                <ImageWithBasePath
                                  src={item.image}
                                  alt={item.title}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover img-blurred-bg"
                                />
                              ) : (
                                <img
                                  src={item.image}
                                  alt={item.title}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover img-blurred-bg"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      ImagesCrousel[
                                        index % ImagesCrousel.length
                                      ].image;
                                  }}
                                />
                              )}

                              {/* Main Image */}
                              {isFallback ? (
                                <ImageWithBasePath
                                  src={item.image}
                                  alt={item.title}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-contain"
                                />
                              ) : (
                                <img
                                  src={item.image}
                                  alt={item.title}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-contain"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      ImagesCrousel[
                                        index % ImagesCrousel.length
                                      ].image;
                                  }}
                                />
                              )}

                              {item.category && (
                                <span className="position-absolute top-0 end-0 m-2 badge bg-white text-navy rounded-pill fw-medium">
                                  {item.category}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
                <div className="col-12 col-lg-4">
                  <Slider {...verticalSettings}>
                    {featureCarouselSlides.map((item, index) => {
                      const isFallback = item.image?.startsWith("assets/");

                      return (
                        <div key={index}>
                          <div
                            className="card border-0 shadow-sm rounded-4 overflow-hidden"
                            style={{
                              height: carouselHeight / 2 - 10,
                            }}
                          >
                            <div
                              className="position-relative bg-light"
                              style={{
                                aspectRatio: "3 / 2",
                                overflow: "hidden",
                              }}
                            >
                              {/* Background Image */}
                              {isFallback ? (
                                <ImageWithBasePath
                                  src={item.image}
                                  alt={item.title || ""}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover img-blurred-bg"
                                />
                              ) : (
                                <img
                                  src={item.image}
                                  alt={item.title || ""}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover img-blurred-bg"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      ImagesCrouselVertical[
                                        index % ImagesCrouselVertical.length
                                      ].image;
                                  }}
                                />
                              )}

                              {/* Main Image */}
                              {isFallback ? (
                                <ImageWithBasePath
                                  src={item.image}
                                  alt={item.title || ""}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-contain"
                                />
                              ) : (
                                <img
                                  src={item.image}
                                  alt={item.title || ""}
                                  className="position-absolute top-0 start-0 w-100 h-100 object-fit-contain"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      ImagesCrouselVertical[
                                        index % ImagesCrouselVertical.length
                                      ].image;
                                  }}
                                />
                              )}

                              {item.category && (
                                <span className="position-absolute top-0 end-0 m-2 badge bg-white text-navy rounded-pill fw-medium">
                                  {item.category}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
              </div>
            </div>
          </section>
        </Spin>
        <footer className="bg-terracotta text-white pt-4">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mb-3 text-start overview-text">
                <ImageWithBasePath
                  src="assets/img/full logo- white.avif"
                  alt="logo"
                  className="img-fluid"
                />
                <div className="mt-3 text-start d-flex align-items-center">
                  <a
                    href="https://www.instagram.com/pereco_india/?igsh=MXFrNXRieHozMHVicA%3D%3D#"
                    className="text-white me-2"
                  >
                    <i className="fa-brands fs-2 fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.facebook.com/Perecoindia/"
                    className="text-white me-2"
                  >
                    <i className="fa-brands fs-2 fa-facebook"></i>
                  </a>
                  <a
                    href="https://x.com/PerecoIndia"
                    className="text-white me-2"
                  >
                    <i className="fa-brands fs-2 fa-x-twitter"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/company/perennial-code/"
                    className="text-white me-2"
                  >
                    <i className="fa-brands fs-2 fa-linkedin"></i>
                  </a>
                  <a
                    href="https://www.youtube.com/@perecoindia"
                    className="text-white me-2"
                  >
                    <i className="fa-brands fs-2 fa-youtube"></i>
                  </a>
                </div>

                <div className="mt-3 text-start">
                  <a
                    href="https://www.google.com/maps/dir//opp.+ASK+Educational+Society,+Vittal+Nagar,+Adikmet,+Hyderabad,+Telangana+500044/@17.4059614,78.4262689,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bcb99a6320e26bb:0x199d77b1f4faac56!2m2!1d78.5086707!2d17.4059783?entry=ttu"
                    className="text-white text-decoration-none d-inline-flex align-items-start justify-content-center"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-solid fa-location-dot fs-2 me-2 mt-1"></i>
                    <span className="text-start">
                      <span className="d-block">
                        Vidya Nagar Street Number 7,{" "}
                      </span>
                      <span className="d-block">
                        Hyderabad,Telangana, 500044
                      </span>
                    </span>
                  </a>
                </div>
              </div>
              <div className="col-md-6 mb-3 overview-text">
                <div className="row">
                  <div className="col-7 mb-5 text-start overview-text">
                    <h4 className="text-white d-inline-block border-bottom border-2 border-white">
                      Contact
                    </h4>

                    <p className="small">
                      <i className="fa-solid fs-4 fa-phone me-2 mt-1"></i> +91
                      8297230010
                    </p>
                    <div className="d-flex align-items-start mb-3 small">
                      <i className="fa-solid fa-envelope fs-4 me-2"></i>

                      <ul className="mb-0 list-unstyled">
                        <li>sales@perennialcode.in</li>
                        <li>support@perennialcode.in</li>
                        <li>info@perennialcode.in</li>
                      </ul>
                    </div>
                  </div>

                  <div className="col-5 text-start overview-text">
                    <h5 className="text-white d-inline-block border-bottom border-2 border-white">
                      Quick Links
                    </h5>
                    <ul className="list-unstyled">
                      <li>
                        <a
                          href="https://www.perennialcode.in/aboutus"
                          className="text-white text-decoration-none"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          About Us
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.perennialcode.in/solutions"
                          className="text-white text-decoration-none"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Solutions
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.perennialcode.in/contactus"
                          className="text-white text-decoration-none"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Contact Us
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://rollcall.perennialcode.in/"
                          className="text-white text-decoration-none"
                        >
                          Demo Application
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <hr className="border-light" />

            <div className="text-center small">
              © 2026 Perennial Code. All Rights Reserved.
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Signin;
